import Photo1 from 'oldAssets/images/static_pages/sales_marketing_strategies/bidding_photo_01.webp';
import Photo2 from 'oldAssets/images/static_pages/sales_marketing_strategies/bidding_photo_02.webp';

import Graph11 from 'oldAssets/images/static_pages/sales_marketing_strategies/graph_1_1.svg';
import Graph12 from 'oldAssets/images/static_pages/sales_marketing_strategies/graph_1_2.svg';
import Graph2 from 'oldAssets/images/static_pages/sales_marketing_strategies/graph_2.svg';
import Image from 'oldAssets/images/static_pages/sales_marketing_strategies/bidding_image.webp';

const images1 = [Graph11, Graph12];
const images2 = [Graph2, Image];
const photos = [Photo1, Photo2];

export { images1, images2, photos };
